import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailImageMetadata } from '../types';
import { calculateThumbnailDisplayRatio, calculateThumbnailFrameWidth } from '../utils';
import { LoadingThumbnailPlaceholder } from './LoadingThumbnailPlaceholder';
import { ThumbnailFrame } from './ThumbnailFrame';

interface Props {
  metadata: ThumbnailImageMetadata;
  targetHeight?: number;
  /** Station logo shown as a soft-pulsing grayscale placeholder while the thumb loads. */
  logoUrl?: string | null;
  stationName?: string;
}

/**
 * Thumbnail-sized loading placeholder. Prefer the station avatar (soft pulse,
 * grayscale) over a black spinner so status cards and stream hover feel branded.
 * Appearance follows the app MUI theme (light/dark).
 */
export function LoadingThumbnail({
  metadata,
  targetHeight = THUMBNAIL_HEIGHT,
  logoUrl,
  stationName,
}: Props) {
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const width = calculateThumbnailFrameWidth(metadata, displayRatio);

  return (
    <ThumbnailFrame>
      <LoadingThumbnailPlaceholder
        width={width}
        height={targetHeight}
        logoUrl={logoUrl}
        stationName={stationName}
      />
    </ThumbnailFrame>
  );
}
